export class SortMetadata {
	public static list (): SortMetadata[] {
		return [
			new SortMetadata('relevance', 'Default', 'search.score() desc, sortableTitle, institutionName'),
			new SortMetadata('instate-asc', 'In-State Costs (Low to High)', 'inState, sortableTitle, institutionName'),
			new SortMetadata('instate-desc', 'In-State Costs (High to Low)', 'inState desc, sortableTitle, institutionName'),
			new SortMetadata('outstate-asc', 'Out-of-State Costs (Low to High)', 'outState, sortableTitle, institutionName'),
			new SortMetadata('outstate-desc', 'Out-of-State Costs (High to Low)', 'outState desc, sortableTitle, institutionName'),
			new SortMetadata('institution', 'Institution Name', 'institutionName, sortableTitle'),
			new SortMetadata('title-asc', 'Title (A-Z)', 'sortableTitle, institutionName'),
			new SortMetadata('title-desc', 'Title (Z-A)', 'sortableTitle desc, institutionName')
		];
	}

	public static default (): SortMetadata {
		return SortMetadata.list()[0];
	}

	public static get (key: string): SortMetadata | undefined {
		return SortMetadata.list().find((s) => s.key === key);
	}

	constructor (public key: string, public label: string, public expression: string) {

	}
}
